import { FormControl, FormGroup, Validators } from '@angular/forms';

export function createGarantieProductForm(): FormGroup<GarantieProductFormModel> {
  return new FormGroup<GarantieProductFormModel>({
    isPremiumSchutz: new FormControl<boolean | null>(null, [Validators.required])
  });
}

export interface GarantieProductFormModel {
  isPremiumSchutz: FormControl<boolean | null>;
}

